import { Button } from '@mantine/core';
import { Edit2 } from 'react-feather';

/**
 * Floating "Edit Notes" button that opens the private notes panel
 * (MED-805 AC #7 + AC #10). Always visible during the session — never
 * disabled — so the participant can pop the notes panel back open after
 * dismissing it.
 *
 * MED-1139 — a labeled pill (pencil + persistent "Edit Notes" text), anchored
 * bottom-LEFT. Two UAT fixes:
 *   - The icon-only pencil read like Zoom's "mark up" control; the always-on
 *     text label makes it obviously the notes button (C-7/C-8).
 *   - Anchored bottom-left so it never overlaps the commitment Save button /
 *     saved-status (which anchor bottom-right of the commitment card) at any
 *     viewport width (A-1/A-2).
 */

export interface NotesPencilFabProps {
  onOpen: () => void;
  isOpen: boolean;
}

export function NotesPencilFab({ onOpen, isOpen }: NotesPencilFabProps) {
  return (
    <Button
      onClick={onOpen}
      variant="white"
      color="dark"
      radius="xl"
      leftSection={<Edit2 size={18} />}
      aria-label={
        isOpen ? 'Close private notes panel' : 'Open private notes panel'
      }
      data-testid="participant-active-notes-fab"
      data-open={isOpen ? 'true' : 'false'}
      style={{
        position: 'fixed',
        bottom: 24,
        left: 24,
        zIndex: 10,
        boxShadow: '0 6px 18px rgba(0, 0, 0, 0.35)',
      }}
    >
      Edit Notes
    </Button>
  );
}
